<div id="preloader">
  <div id="status"><img alt="" src="/assets/images/loader-img.gif"></div>
</div>
